function sources(core, endpoint, solrServer) {
    core = core || ""
    endpoint = endpoint || ""
    solrServer = solrServer || ""
    return {
        'endpoint': endpoint,
        'url': [solrServer,core,'/itr'].join(''),
        'path': [core,'/itr'].join('')
    }
}

export {
    sources
}

export default {
    sources
}


//////////////////
// WEBPACK FOOTER
// /data/code/gitlab/crossasia-itr-solr-setting/sources.js
// module id = +7Fq
// module chunks = 1